import React from 'react';
import { Architecture } from '../components/architecture';
import { MassEdit } from '../components/massEdit';
import { MyConfig } from '../components/myConfig/MyConfig';
import { MySM } from '../components/mySm';
import { OfferPoster } from '../components/offerPoster';
import { PersonalOffer } from '../components/personalOffer/PersonalOffer';
import { Redirect } from '../components/redirect';

export interface AppRouteProps {
  Component: React.ComponentType;
  path: string;
}

const ROUTES: AppRouteProps[] = [
  {
    path: '/',
    Component: Redirect,
  },
  {
    path: '/personal-offer',
    Component: Redirect,
  },
  {
    path: '/personal-offer/my-view',
    Component: PersonalOffer,
  },
  {
    path: '/personal-offer/my-view/sm',
    Component: MySM,
  },
  {
    path: '/personal-offer/my-config',
    Component: MyConfig,
  },
  {
    path: '/personal-offer/mass-edit',
    Component: MassEdit,
  },
  {
    path: '/personal-offer/offer-poster',
    Component: OfferPoster,
  },
  {
    path: '/personal-offer/architecture',
    Component: Architecture,
  },
  {
    path: '*',
    Component: Redirect,
  },
];

export default ROUTES;
